export default __webpack_public_path__ + "static/media/typescriptlogo.e0cf5672.svg";